<template>
  <div class="VerificationCode">
    <app-header :title="$t('registerlogin.register_login')" @on-click="goBack"></app-header>
    <div class="code-con">
        <div class="tips1">
            {{ $t("forgotPwd.verification_code_has_been_sent") }}
            <span dir="ltr">{{ "+" + telprex + ' ' + phone }}</span>
        </div>
        <van-field 
            @touchstart="handleForceFocus('verifCodeInput')"
            ref="verifCodeInput"
            v-model.trim="verificationCode" 
            :name="$t('forgotPwd.verification_code')" 
            clearable 
            class="field-input" 
            clear-trigger="always" 
            :placeholder="$t('forgotPwd.verification_code')" 
        >
            <template #left-icon>
              <i class="fas fa-key icon-color f16"></i>
            </template>
        </van-field>
        <div class="tips2">
        {{ $t("forgotPwd.no_verification_code_received") }}
        <span v-if="countdown <= 0" class="forgotPwd-resend" @click="handlerSend()">{{ $t("forgotPwd.resend") }}</span>
        <span v-else>{{ $t("forgotPwd.resend") }}（{{ countdown }}s）</span>
        </div>
        <van-button class="login-btn" :disabled="!verificationCode" round block type="info" @click="onConfirm">{{ $t("registerlogin.confirm") }}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerificationCode",
  data() {
    return {
      verificationCode: "",
      countdown: 60,
    };
  },
  props:{
    telprex: {
        type: String,
        default: ''
    },
    phone: {
        type: String,
        default: ''
    },
    enterpriseCode: {
        type: String,
        default: ''
    },
  },
  mounted(){
      this.startCountdown();
  },
  methods: {
    goBack() {
        this.$emit('cancel')
    },
    onConfirm() {
        this.$emit('onConfirm',this.verificationCode)
    },
    // 输入框获取焦点
    handleForceFocus(ref) {
      this.$refs[ref].focus();
    },
    handlerSend() {
          this.$http
          .post({
            url: "/bss/app/noauth/GetVerificationCodeBySMS",
            data: {
              phone: this.phone,
              nationNum: this.telprex,
              businessType: '1',
              enterpriseCode: this.enterpriseCode,
            },
            auth:false,
          })
          .then((res) => {
            this.startCountdown();
          })
          .catch((err) => {
            this.countdown = 0;
            console.log(err);
            this.$toast(err);
          });

          // 神策-点击发送验证码
          this.$sensors.track('WebGetCodeClick', {
            service_type: '注册',
            get_type: '手机号',
            account: this.telprex + this.phone,
          });
    },
    // 启动倒计时
    startCountdown(expireTime) {
      // 1. 避免重复点击
      if (this.isCounting) return;

      // 2. 初始化状态
      this.isCounting = true;
      this.countdown = 60;

      // 4. 启动计时器
      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          this.stopCountdown();
          return;
        }
        this.countdown--;
      }, 1000);
    },

    // 停止倒计时
    stopCountdown() {
      clearInterval(this.timer);
      this.isCounting = false;
      this.countdown = 0;
    },
  },
  // 组件销毁时清理定时器
  beforeDestroy() {
    this.stopCountdown();
  },
};
</script>

<style lang="less" scoped>
.VerificationCode {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 100;
  background-color: #fff;
  .icon-color {
      color: #99a1af;
  }
  .code-con {
      padding: 30px 20px 0;
  }
  .field-input {
        background-color: #fff;
        border: 1px solid #d1d5dc;
        border-radius: 8px;
        &:focus-within {
            background: rgba(67, 97, 238, 0.05);
            border: 1px solid #4361ee;
        }
    }
    .login-btn {
        background-color: #4361ee;
        border-radius: 6px;
        border:#4361ee;
        margin-top: 25px;
    }
    .forgotPwd-resend {
        color: #4361ee;
    }
    .tips1 {
        margin-bottom: 20px;
        font-size: 13px;
        -webkit-text-size-adjust: none
    }
    .tips2 {
        margin-top: 8px;
        font-size: 12px;
        color: #929292;
        -webkit-text-size-adjust: none
    }
}
html[dir="rtl"] .VerificationCode {
      ::v-deep {
          .van-field__control,.van-field__error-message {
            text-align: right;
          }
          .van-field__left-icon {
              margin-right: unset;
              margin-left: 0.111111rem;
          }
      }
}
</style>